import { useMemo } from "react";
import { useCompanySlug } from "@/entities/company/hooks/use-company-slug";
import { useFetchAuthenticatedUserQuery } from "@/entities/me/api/fetch-authenticated-user";

export const useCompany = () => {
  const companySlug = useCompanySlug();
  const { companies } = useFetchAuthenticatedUserQuery();

  return useMemo(
    () => companies.find((c) => c.slug === companySlug) ?? null,
    [companies, companySlug],
  );
};
